import {
  Pie,
  mixins
} from 'vue-chartjs'
const {
  reactiveProp
} = mixins

export default Pie.extend({
  mixins: [reactiveProp],
  props: ['options'],
  watch: {
    'options': {
      handler(newOption, oldOption) {
        this._chart.destroy()
        this.renderChart(this.chartData, this.options)
      },
      deep: true
    }
  },
  mounted() {      
    this.renderChart(this.chartData, {responsive: true, maintainAspectRadio: false})
  }
})



// WEBPACK FOOTER //
// ./src/components/Charts/PieChart_Ducts.js